import { CommentList } from "app/comment/CommentList";
import { AlertMessage } from "app/components/AlertMessage";
import SimpleDateView from "app/components/SimpleDateView";

export const StoryViewItem = ({ story, children = null, useComment = false, showCommentCount = false }) => {

    let imageUrl = story?.user?.image;
    if (imageUrl === null || imageUrl === '' || story.user === null) {
        imageUrl = `${process.env.PUBLIC_URL}/static/images/user/basic_badge.png`
    }

    if (story === null) return null;

    return (
        <div className="storyView contents">
            <div className={`view ${story.deleteYn === "Y" ? "deleteContainer" : ""}`}>
                <div>

                    <AlertMessage type="delete" visible={story.deleteYn === "Y"} />
                    <div className="head">
                        <div className="head_top">
                            <div className="profile">
                                <img src={imageUrl} alt="사용자 프로필 이미지" />
                                <div className="info">
                                    <p>{story.user?.schoolName.replace('초등학교', '초')} {story.user?.grade}학년 {story.user?.name || story.name}</p>
                                    <p className="time"><SimpleDateView date={story.createdAt} /></p>
                                </div>
                            </div>
                            {story.deleteYn !== "Y" && <span className={`label_answer ${story.replyYn === 'Y' && 'register'}`}>{story.replyYn === 'Y' ? '답변등록완료' : '답변미등록'}</span>}
                        </div>
                        <div className="head_bottom">
                            <h2 className="title">{story.title}</h2>
                            <div className="count">
                                <p><i className="fa-solid fa-comment-dots"></i>{story.commentCount}</p>
                                <p><i className="fa-solid fa-thumbs-up"></i>{story.likeCount}</p>
                                <p><i className="fa-solid fa-eye"></i>{story.readCount}</p>
                            </div>
                        </div>
                    </div>

                    <div className="writing">{story.content}</div>

                    {children}

                    <div className="answer_teacher">
                        <h4 className="title">훈장님 생각 💬</h4>
                        <div className="answer">{story.replyYn === 'Y' ? story.reply : '아직 답변이 등록되지 않았습니다.'}</div>
                    </div>

                    {showCommentCount &&
                        <div className="comment_title"><i className="fa-regular fa-comment"></i> 생각나누기 {story.commentCount}</div>
                    }


                    {useComment && <CommentList type="DONGWHA" readOnly={story.deleteYn === "Y"} root={story} />}
                </div>
            </div>
        </div>
    );
}